module.exports = __webpack_public_path__ + "da3fb6a45f9addf7e96448558071a809.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./example/images/challenge.jpg
 ** module id = 286
 ** module chunks = 0
 **/